import { api } from "./api";

export const conversationApi = api.injectEndpoints({
  endpoints: (build) => ({
    sendMessage: build.mutation({
      query: ({ customer, message }) => ({
        url: "/assistant/conversations/send",
        method: "POST",
        body: { customer, message },
      }),
    }),
    generateResponse: build.mutation({
      query: (id) => ({
        url: `/assistant/conversations/generateResponse/${id}`,
        method: "POST",
      }),
    }),
    listConversations: build.query({
      query: ({ page }) => ({
        url: `/assistant/conversations?page=${page}`,
        method: "GET",
      }),
      // serializeQueryArgs: ({ queryArgs }) =>
      //   queryArgs && queryArgs.page,
      // merge: (currentItems, newItems) => {
      //   currentItems.docs.push(...newItems.docs);
      // },
      // forceRefetch: ({ currentArg, previousArg }) =>
      //   currentArg !== previousArg,
    }),
    listMessages: build.query({
      query: ({ page, conversation }) => ({
        url: `/assistant/conversations/messages?conversation=${conversation}&page=${page}`,
        method: "GET",
      }),
    }),
    getConversation: build.query({
      query: (id) => ({
        url: `/assistant/conversations/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useSendMessageMutation,
  useListConversationsQuery,
  useLazyListConversationsQuery,
  useListMessagesQuery,
} = conversationApi;
